export default __webpack_public_path__ + "static/media/tel.c49b9f85.svg";